(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections--fortop-brand"] && !window.DesignMode) return;
  try {
    
  let mySwiper = null;
  const mediaQuery = window.matchMedia('(max-width: 1024px)');

  const checkBreakpoint = (e) => {
    if (e.matches) {
      initSwiper();
    } else if (mySwiper) {
      mySwiper.destroy(false, true);
    }
  }

  const initSwiper = () => {
    mySwiper = new Swiper('.fortop-swipe-brand .swiper', {
      slidesPerView: 2,
      spaceBetween: 15,
      loop: false,
      autoplay: false,
      grabCursor: true,
      pagination: {
        el: '.fortop-swipe-brand .swiper-pagination',
        //type: 'bullets',
        //clickable: true,
        renderBullet: (index, className) => {
        //let num = ('00' + (index + 1)).slice(-2);
        return '<span class="' + className + ' dot">' + '</span>';
      },
      },
      navigation: {
        nextEl: '.fortop-swipe-brand .swiper .swiper-button-next',
        prevEl: '.fortop-swipe-brand .swiper .swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView: 2,
        }
      },
    });
  };

  mediaQuery.addListener(checkBreakpoint);
  checkBreakpoint(mediaQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections--fortop-cate"] && !window.DesignMode) return;
  try {
    
  let mySwiper = null;
  const mediaQuery = window.matchMedia('(max-width: 1024px)');

  const checkBreakpoint = (e) => {
    if (e.matches) {
      initSwiper();
    } else if (mySwiper) {
      mySwiper.destroy(false, true);
    }
  }

  const initSwiper = () => {
    mySwiper = new Swiper('.fortop-swipe-cate .swiper', {
      slidesPerView: 2,
      spaceBetween: 15,
      loop: false,
      autoplay: false,
      grabCursor: true,
      pagination: {
        el: '.swiper-pagination',
        //type: 'bullets',
        renderBullet: (index, className) => {
        //let num = ('00' + (index + 1)).slice(-2);
        return '<span class="' + className + ' dot">' + '</span>';
      },
      },
      navigation: {
        nextEl: '.fortop-swipe-cate .swiper .swiper-button-next',
        prevEl: '.fortop-swipe-cate .swiper .swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView: 2,
        }
      },
    });
  };

  mediaQuery.addListener(checkBreakpoint);
  checkBreakpoint(mediaQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections-fortop-brand_update"] && !window.DesignMode) return;
  try {
    
  let mySwiper = null;
  const mediaQuery = window.matchMedia('(max-width: 1024px)');

  const checkBreakpoint = (e) => {
    if (e.matches) {
      initSwiper();
    } else if (mySwiper) {
      mySwiper.destroy(false, true);
    }
  }

  const initSwiper = () => {
    mySwiper = new Swiper('.fortop-swipe-brand .swiper', {
      slidesPerView: 2,
      spaceBetween: 15,
      loop: false,
      autoplay: false,
      grabCursor: true,
      pagination: {
        el: '.fortop-swipe-brand .swiper-pagination',
        //type: 'bullets',
        //clickable: true,
        renderBullet: (index, className) => {
        //let num = ('00' + (index + 1)).slice(-2);
        return '<span class="' + className + ' dot">' + '</span>';
      },
      },
      navigation: {
        nextEl: '.fortop-swipe-brand .swiper .swiper-button-next',
        prevEl: '.fortop-swipe-brand .swiper .swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView: 2,
        }
      },
    });
  };

  mediaQuery.addListener(checkBreakpoint);
  checkBreakpoint(mediaQuery);

  } catch(e) { console.error(e); }
})();
})();
